import api from './api'

export const getRateByQuery = params => {
  return api.post(`/CloudParkAPI/Rate/GetRateByQuery`, params)
}
export const getRateParamById = (params) => {
  return api.post(`/CloudParkAPI/Rate/GetRateParamById`, params)
}
export const loadRateDDLSource = params => {
  return api.post(`/CloudParkAPI/Rate/LoadRateDDLSource`, params)
}
export const getRateGroupByCustId = params => {
  return api.post(`/CloudParkAPI/Rate/GetRateGroupByCustId`, params)
}
export const saveRate = params => {
  return api.post(`/CloudParkAPI/Rate/SaveRate`, params)
}
export const deleteRate = (params) => {
  return api.post(`/CloudParkAPI/Rate/DeleteRate`, params)
}
export const synRateById = params => {
  return api.post(`/CloudParkAPI/Rate/SynRateById`, params)
}
export const getHolidayByQuery = params => {
  return api.post(`/CloudParkAPI/Rate/GetHolidayByQuery`, params)
}
export const saveHoliday = params => {
  return api.post(`/CloudParkAPI/Rate/SaveHoliday`, params)
}
export const deleteHoliday = params => {
  return api.post(`/CloudParkAPI/Rate/DeleteHoliday`, params)
}
export const synHolidayById = params => {
  return api.post(`/CloudParkAPI/Rate/SynHolidayById`, params)
}
export const getTempRateByQuery = params => {
  return api.post(`/CloudParkAPI/Rate/GetTempRateByQuery`, params)
}
export const saveTempRate = params => {
  return api.post(`/CloudParkAPI/Rate/SaveTempRate`, params)
}
export const deleteTempRate = (params) => {
  return api.post(`/CloudParkAPI/Rate/DeleteTempRate`, params)
}
export const synTempRateById = params => {
  return api.post(`/CloudParkAPI/Rate/SynTempRateById`, params)
}



// WEBPACK FOOTER //
// ./src/api/rate.js